/// <amd-module name="VSS/ActionHelpers/ActionHelpers" />

// Main purpose of these helpers is to use actions with useReducer hook.
export interface Action<T extends string = string, P = any> {
    type: T;
    payload?: P;
}

export function createAction<T extends string, P>(type: T, payload?: P): Action<T, P> {
    return { type, payload };
}

type ActionsCreatorsMapObject = { [actionCreator: string]: (...args: any[]) => any };
export type ActionsUnion<A extends ActionsCreatorsMapObject> = ReturnType<A[keyof A]>;
export type ActionsOfType<ActionUnion, ActionType extends string> = ActionUnion extends Action<ActionType> ? ActionUnion : never;
